import { z } from 'zod'

export const ValidatorVerdictSchema = z.enum(['ok', 'partial', 'gaps', 'error', 'pending'])
export type ValidatorVerdict = z.infer<typeof ValidatorVerdictSchema>

export const ValidatorGapSchema = z.object({
  capability: z.string(),
  suggested_tool_name: z.string().nullable().optional(),
})
export type ValidatorGap = z.infer<typeof ValidatorGapSchema>

export const SkillValidatorSchema = z.object({
  verdict: ValidatorVerdictSchema,
  summary: z.string().nullable(),
  matched_tools: z.array(z.string()),
  gaps: z.array(ValidatorGapSchema),
  ran_at: z.string().nullable(),
})
export type SkillValidator = z.infer<typeof SkillValidatorSchema>

export const SkillDisplaySchema = z
  .object({
    surface_kind: z.string().optional(),
    renderer_hint: z.string().optional(),
    default_template: z.string().optional(),
  })
  .passthrough()
export type SkillDisplay = z.infer<typeof SkillDisplaySchema>

export const SkillSchema = z.object({
  skill_id: z.string(),
  user_sub: z.string().nullable(),
  is_system: z.boolean(),
  name: z.string(),
  description: z.string(),
  system_prompt: z.string(),
  tool_allowlist: z.array(z.string()),
  input_schema: z.record(z.unknown()),
  display: SkillDisplaySchema,
  validator: SkillValidatorSchema,
  created_at: z.string(),
  updated_at: z.string(),
})
export type Skill = z.infer<typeof SkillSchema>

export const SkillCreateRequestSchema = z.object({
  name: z.string().min(1, 'Name is required').max(120),
  description: z.string().min(1, 'Description is required').max(500),
  system_prompt: z.string().min(1, 'System prompt is required'),
  tool_allowlist: z.array(z.string()),
  input_schema: z.record(z.unknown()),
  display: SkillDisplaySchema,
})
export type SkillCreateRequest = z.infer<typeof SkillCreateRequestSchema>

export const SkillUpdateRequestSchema = SkillCreateRequestSchema.partial()
export type SkillUpdateRequest = z.infer<typeof SkillUpdateRequestSchema>

export const ToolRequestStatusSchema = z.enum(['open', 'acknowledged', 'shipped', 'rejected'])
export type ToolRequestStatus = z.infer<typeof ToolRequestStatusSchema>

export const ToolRequestSchema = z.object({
  id: z.number(),
  user_sub: z.string(),
  skill_id: z.string().nullable(),
  capability: z.string(),
  suggested_tool_name: z.string().nullable(),
  status: ToolRequestStatusSchema,
  created_at: z.string(),
  updated_at: z.string(),
})
export type ToolRequest = z.infer<typeof ToolRequestSchema>

export const ToolRequestCreateSchema = z.object({
  capability: z.string().min(1, 'Capability is required').max(500),
  suggested_tool_name: z.string().max(120).optional().nullable(),
  skill_id: z.string().nullable().optional(),
})
export type ToolRequestCreate = z.infer<typeof ToolRequestCreateSchema>

export const ToolDescriptorSchema = z.object({
  name: z.string(),
  description: z.string(),
  input_schema: z.record(z.unknown()),
})
export type ToolDescriptor = z.infer<typeof ToolDescriptorSchema>
